<template>
  <b-overlay
    :show="loading"
    rounded="sm"
  >
    <b-row>
      <b-col>
        <b-card
          title="جزئیات دسته بندی غذا"
        >
          <b-form
            ref="foodcategoryform"
            @submit.prevent
          >
            <b-row>

              <b-col
                class="mt-2"
                md="6"
                offset-md="3"
              >
                <b-row>
                  <b-col md="12" xl="6" class="mb-1">
                    <b-form-group
                      label="عنوان"
                      label-for="Title"
                    >
                      <b-form-input
                        id="Title"
                        v-model="Form.Title"
                        name="Title"
                        autocomplete="off"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col md="12" xl="6" class="mb-1">
                    <b-form-group
                        label="معادل فارسی"
                        label-for="PersianEquivalent"
                    >
                      <b-form-input
                          id="PersianEquivalent"
                          v-model="Form.PersianEquivalent"
                          name="PersianEquivalent"
                          autocomplete="off"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col md="12" class="mb-1">
                    <b-form-group
                        label="توضیحات"
                        label-for="Description"
                    >
                      <div class="form-label-group">
                        <b-form-textarea
                            id="Description"
                            v-model="Form.Description"
                            name="Description"
                            autocomplete="off"
                        />
                      </div>
                    </b-form-group>
                  </b-col>
                  <b-col md="12" class="mb-1">
                    <fm-file-select v-model="Form.Image" label="عکس" />
                  </b-col>
                  <b-col md="12" class="mb-1">
                    <p>اولویت نمایش در وعده های مختلف</p>
                    <b-row>
                      <b-col md="4">
                        <b-form-group
                            label="اولویت صبحانه"
                            label-for="BreakfastOrder"
                        >
                          <b-form-input
                              id="BreakfastOrder"
                              v-model.number="Form.BreakfastOrder"
                              type="number"
                              name="BreakfastOrder"
                              autocomplete="off"
                          />
                        </b-form-group>
                      </b-col>
                      <b-col md="4">
                        <b-form-group
                            label="اولویت ناهار"
                            label-for="LunchOrder"
                        >
                          <b-form-input
                              id="LunchOrder"
                              v-model.number="Form.LunchOrder"
                              type="number"
                              name="LunchOrder"
                              autocomplete="off"
                          />
                        </b-form-group>
                      </b-col>
                      <b-col md="4">
                        <b-form-group
                            label="اولویت شام"
                            label-for="DinnerOrder"
                        >
                          <b-form-input
                              id="DinnerOrder"
                              v-model.number="Form.DinnerOrder"
                              type="number"
                              name="DinnerOrder"
                              autocomplete="off"
                          />
                        </b-form-group>
                      </b-col>
                      <b-col md="4">
                        <b-form-group
                            label="اولویت میان وعده صبح"
                            label-for="MorningSnackOrder"
                        >
                          <b-form-input
                              id="MorningSnackOrder"
                              v-model.number="Form.MorningSnackOrder"
                              type="number"
                              name="MorningSnackOrder"
                              autocomplete="off"
                          />
                        </b-form-group>
                      </b-col>
                      <b-col md="4">
                        <b-form-group
                            label="اولویت میان وعده عصر"
                            label-for="EveningsnackOrder"
                        >
                          <b-form-input
                              id="EveningsnackOrder"
                              v-model.number="Form.EveningsnackOrder"
                              type="number"
                              name="EveningsnackOrder"
                              autocomplete="off"
                          />
                        </b-form-group>
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-col md="12" class="mt-1 mb-2 text-center">
                    <b-button
                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                      type="submit"
                      variant="primary"
                      class="mr-1"
                      @click="save"
                    >
                      ذخیره
                    </b-button>
                    <b-button
                      v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                      variant="outline-secondary"
                      @click="back"
                    >
                      بازگشت
                    </b-button>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </b-overlay>
</template>

<script>
import FmFileSelect from "@/views/menu/file-manager/components/fmFileSelect.vue";
export default {
  name: 'FoodCategoryDetails',
  components: { FmFileSelect },
  data() {
    return {
      Form: {
        Id: null,
        Title: null,
        Image: null,
        Description: null,
        BreakfastOrder: null,
        LunchOrder: null,
        DinnerOrder: null,
        EveningsnackOrder: null,
        MorningSnackOrder: null,
        PersianEquivalent: null
      },
      loading: false,
    }
  },
  created() {
    if (this.$route.params.id) {
      this.Form.Id = this.$route.params.id
      this.get()
    }
  },
  methods: {
    save() {
      let url = this.$api.foodcategory.add
      if (this.$route.params.id) {
        url = this.$api.foodcategory.update
      }

      this.loading = true
      this.$http.post(url, this.Form)
        .then(() => {
          this.back()
        })
        .finally(() => {
          this.loading = false
        })
    },
    imageRenderer(event) {
      const fileReader = new FileReader()
      fileReader.readAsDataURL(event.target.files[0])

      fileReader.onload = () => {
        this.Form.Image = fileReader.result
      }
    },
    get() {
      this.loading = true
      this.$http.post(
        this.$api.foodcategory.get, {
          Id: this.Form.Id,
        },
      )
        .then(res => {
          this.loading = false
          this.Form = res.data
        })
    },
  },
}
</script>

<style scoped>
.image .media-body {
  align-self: flex-end;
}
</style>
